var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12416",
    "data-name": "Group 12416",
    transform: "translate(-16512 -8949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(16512 8949)",
    fill: "#4a90f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12408",
    "data-name": "Group 12408",
    transform: "translate(-131 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_create_24px",
    d: "M3,8.584v1.47H4.47L8.8,5.719l-1.47-1.47Zm6.942-4a.39.39,0,0,0,0-.553l-.917-.917a.39.39,0,0,0-.553,0l-.717.717L9.224,5.3l.717-.717Z",
    transform: "translate(16656.055 8938.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_repeat_24px",
    d: "M7.7,7.878H19.459v3.527l4.7-4.7L19.459,2V5.527H5.351v7.054H7.7ZM19.459,19.635H7.7V16.108L3,20.811l4.7,4.7V21.986H21.811V14.932H19.459Z",
    transform: "translate(16649 8931)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSwitch);
export default __webpack_public_path__ + "static/media/op-switch.c7a51634c9c50114a1d6f9d28d5ff51d.svg";
export { ForwardRef as ReactComponent };